<div class='mt-16 p-16 actual-trip-group-item mat-elevation-z2'>
	<div class="item">
		<span class="description">{{item.trip_resource.description}}</span>
		<button mat-icon-button color='warn' (click)='delete.emit()'>
			<mat-icon>delete</mat-icon>
		</button>
	</div>
</div>